import { render } from "./KioskIconPicker.vue?vue&type=template&id=7d74e485&scoped=true"
import script from "./KioskIconPicker.vue?vue&type=script&lang=js"
export * from "./KioskIconPicker.vue?vue&type=script&lang=js"

import "./KioskIconPicker.vue?vue&type=style&index=0&id=7d74e485&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d74e485"]])

export default __exports__